export const ORDER_LIST_PAGE_PATH = '/order/list'

export const LISTING_LIST_PAGE_PATH = '/listing/list'

export const LISTING_DETAIL_PAGE_PATH = '/listing/detail'

export const LISTING_RESULT_PAGE_PATH = '/listing/result'
